module.exports = __webpack_public_path__ + "img/packages/h2.a623b2.png";